import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { IonSelect } from "@ionic/angular";

@Component({
    selector: "app-language-selection-component",
    templateUrl: "./language-selection.component.html",
    styleUrls: ["./language-selection.component.scss"],
    standalone: false
})
export class LanguageSelectionComponent {
  faGlobe = faGlobe;

  @ViewChild("inputSelectedLanguage") languageSelectRef: IonSelect;

  @Input() language: string;
  @Input() useLanguageCode: boolean = false;

  @Output("changeLanguage") changeLanguageEmitter = new EventEmitter<string>();

  constructor() {}

  openLanguageSelect(event: UIEvent) {
    if (this.languageSelectRef) {
      this.languageSelectRef.open(event);
    }
  }

  selectedLanguage(language: string) {
    return language ? language.toUpperCase() : "";
  }

  changeLanguage(language: string) {
    this.changeLanguageEmitter.emit(language);
  }
}
